$(function(){

    $('.js-course-details-attendee, .js-course-details-attendee-back').on('click', function(){

        //open modal & close the current active courses details
        const dataID = $(this).data('id');
        $('.js-active-courses-attendee').toggle();
        $('.active-courses__details[data-id="'+ dataID +'"]').toggleClass('hide');

    });



});